import { useContext } from "react";

function useValidContext(ContextObject, hookName, providerName) {
    const context = useContext(ContextObject);
    if (!context) {
        throw new Error(
            `${hookName} must be called inside of ${providerName} provider.`
        );
    }

    return context;
}

export default useValidContext;
